/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

// Redux Store
import { isEmpty } from "lodash";

import { dateToFormat, yesterDay } from "../../utils/date";
import Calendar from "../Calendar/Calendar";


import { ColCard } from "../ContentLayout";
import { getCompanyManagerSchedules } from "../../apis/admin/companies";

const CareCompanyScheduleCalendar = ({
  company,
  managerCompany,
  setSchedule,
  toggle,
  setToggle,
  setFormType,
}) => {
  const calendarRef = useRef(null);
  const [event, setEvent] = useState([]);
  const [, setSelectedSchedule] = useState(null)
  const [dateParams, setDateParams] = useState({
    from: "",
    to: "",
  });

  useEffect(() => {
    if (company && managerCompany) {
      getCalendarData();
    }
  }, [dateParams, company, managerCompany, toggle]);

  const getCalendarData = () => {
    if (isEmpty(dateParams.from) && isEmpty(dateParams.to)) return;
    getCompanyManagerSchedules(managerCompany.companyIdx, company.companyIdx, { range: { date: dateParams } })
      .then((res) => {
        setEvent(res.data.schedules.map((data) => ({
          title: data.title + " ["+ (data.completed === 1 ? "처리" : "미처리") +"]",
          date: data.date,
          data
        })));
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const clickEvent = useCallback((params) => {
    setSchedule(params.event.extendedProps.data)
    setFormType("view")
    setToggle(true)
  }, [setSelectedSchedule])

  const onMonthChage = (date) => {
    const from = dateToFormat(date.view.currentStart);
    const to = dateToFormat(yesterDay(date.view.currentEnd));

    setDateParams({
      from,
      to,
    });
  };

  return (
    <div className="care-company-schedule-calendar">
      <ColCard cardBody={{ className: "padding-0" }}>
        <Calendar
          forwardedRef={calendarRef}
          event={event}
          onMonthChage={onMonthChage}
          eventClick={clickEvent}
        />
      </ColCard>
    </div>
  );
};


export default CareCompanyScheduleCalendar;
